import React from 'react'
import LeftSideBar from '../../components/LeftSideBar';
import Title from '../../components/Title';

export const Tax_Audit_Services = () => {
    return (
        <div className='services_main_wrapper'>
            <div className='container'>
                <div className='row mt-5 mb-5'>
                    <div className='col-md-3'>
                        <LeftSideBar />
                    </div>
                    <div className='col-md-9'>
                        <div className='right_side_content'>
                            <div className='section_main_title gst_classification_title d-flex align-items-center justify-content-between'>
                                <div className='title_and_icon d-flex align-items-center'>
                                    <img src='/images/tax-audit.png'></img>
                                    <Title text="Tax Audit Services" className="custom-heading" />
                                </div>
                                <ul className='d-flex align-items-center'>
                                    <li className='green'>Accuracy</li>
                                    <li className='orange'>Compliance</li>
                                    <li className='light-blue'>Confidence</li>
                                </ul>
                            </div>
                            <div className='discriptions'>
                                <p>A tax audit is more than just a regulatory requirement—it’s a critical tool for ensuring accuracy, compliance, and financial integrity in your business operations. At Vanani & Associates, we go beyond mere compliance, offering strategic tax audit services that add value to your organization. Our aim is to ensure that your tax records are accurate, transparent, and compliant with the latest provisions of the Income Tax Act, 1961.</p>
                            </div>
                            <section className="tax-audit-diagonal">
                                <div className="tax-audit-inner">
                                    {/* Left Side */}
                                    <div className="tax-audit-left">
                                        <img
                                            src="/images/tax_audit_left.png"
                                            alt="Tax Audit Illustration"
                                        />
                                        <h2>
                                            What is a <span>Tax Audit?</span>
                                        </h2>
                                    </div>

                                    {/* Right Side */}
                                    <div className="tax-audit-right">
                                        <p>
                                            <ul>
                                                <li className='mb-3'>A <strong>tax audit</strong> is a systematic examination of the financial records of a business or individual to ensure they adhere to the tax regulations outlined in Section 44AB of the Income Tax Act, 1961. It involves an independent Chartered Accountant verifying the financial data, ensuring proper maintenance of books of accounts, and reporting on compliance with applicable laws through Form 3CA/3CB and Form 3CD.</li>
                                                <li>This process helps businesses and individuals mitigate tax risks, optimize deductions, and avoid penalties, providing confidence to stakeholders about the financial credibility of the entity.</li>
                                            </ul>
                                        </p>

                                    </div>
                                </div>
                            </section>
                            <section className="gst-highlight-flow">
                                <h4 className="section_title mb-0"><sapn className="key_features">Key Applicability of</sapn> Tax Audit </h4>
                                <div className="flow-item">
                                    <div className="flow-icon">📈</div>
                                    <div className="flow-text">
                                        <h3>For Businesses</h3>
                                        <ul className='px-3'>
                                            <li className='mb-2'>Turnover or gross receipts exceeding <strong>₹1 crore.</strong></li>
                                            <li className='mb-2'><strong>₹2 crore</strong> for businesses opting for <strong>presumptive taxation under Section 44AD.</strong></li>
                                            <li><strong>₹5 crore</strong> for entities where cash transactions do not exceed 5% of total receipts or payments.</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="flow-item">
                                    <div className="flow-icon">👨‍💼</div>
                                    <div className="flow-text">
                                        <h3>For Professionals</h3>
                                        <ul className='px-3'>
                                            <li>Gross receipts exceeding <strong>₹50 lakh</strong> annually.</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="flow-item">
                                    <div className="flow-icon">⚖️</div>
                                    <div className="flow-text">
                                        <h3>For Other Cases</h3>
                                        <ul className='px-3'>
                                            <li>Taxpayers declaring lower profits under presumptive taxation schemes such as Sections <strong>44AD, 44ADA,</strong> or <strong>44AE.</strong></li>
                                        </ul>
                                    </div>
                                </div>
                            </section>
                            <section className="tax-audit-deadline">
                                <h4 className="section_title">
                                    <span className="highlight">Updated</span> Deadlines & Penalties
                                </h4>

                                <div className="deadline-container">
                                    {/* Deadline */}
                                    <div className="deadline-card">
                                    <div className="deadline-icon">
                                        📅
                                    </div>
                                    <div className="deadline-text">
                                        <h3>Tax Audit Due Date</h3>
                                        <p>
                                        The tax audit report must be filed by
                                        <strong> 30th September</strong> of the
                                        relevant assessment year.
                                        </p>
                                    </div>
                                    </div>

                                    {/* Penalty */}
                                    <div className="deadline-card">
                                    <div className="deadline-icon">
                                        ⚠️
                                    </div>
                                    <div className="deadline-text">
                                        <h3>Penalty for Non-Compliance</h3>
                                        <p>
                                        Failure to file the tax audit report attracts a penalty under
                                        Section 271B, which is the lower of:
                                        </p>
                                        <ul>
                                        <li>
                                            <strong>0.5% of total turnover/gross receipts, or</strong>
                                        </li>
                                        <li>
                                            <strong>₹1,50,000</strong>
                                        </li>
                                        </ul>
                                    </div>
                                    </div>
                                </div>
                            </section>
                            <section className="tax-audit-objectives">
                                <div className="container">
                                    <h2 className="section-title mb-5 mt-4">
                                        Comprehensive Objectives of a <span>Tax Audit</span>
                                    </h2>
                                    <div className="objectives-wrapper">

                                        <div className="objective-card">
                                            <div className="card-number">1</div>
                                            <h3>Ensuring Financial Integrity</h3>
                                            <ul className='px-3 mx-1 mb-0'>
                                                <li className='mb-2'>Verifying the correctness and accuracy of books of accounts.</li>
                                                <li>Providing certification from a Chartered Accountant.</li>
                                            </ul>
                                        </div>

                                        <div className="objective-card">
                                            <div className="card-number">2</div>
                                            <h3>Facilitating Accurate Tax Filing</h3>
                                            <ul className='px-3 mx-1 mb-0'>
                                                <li>Ensuring that income, deductions, and tax liability are accurately calculated and reflected in tax returns.</li>
                                            </ul>
                                        </div>

                                        <div className="objective-card">
                                            <div className="card-number">3</div>
                                            <h3>Identifying Discrepancies</h3>
                                            <ul className='px-3 mx-1 mb-0'>
                                                <li>Highlighting errors or misstatements in financial records for timely corrections.</li>
                                            </ul>
                                        </div>

                                        <div className="objective-card">
                                            <div className="card-number">4</div>
                                            <h3>Optimizing Compliance</h3>
                                            <ul className='px-3 mx-1 mb-0'>
                                                <li>Verifying adherence to provisions of the Income Tax Act and mitigating risks of penalties or disputes.</li>
                                            </ul>
                                        </div>

                                        <div className="objective-card">
                                            <div className="card-number">5</div>
                                            <h3>Improving Stakeholder Confidence</h3>
                                            <ul className='px-3 mx-1 mb-0'>
                                                <li>Demonstrating financial transparency and compliance to lenders, investors, and authorities.</li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            </section>
                            <div className='check_list_wrap mt-5 mb-5 icon_img'>
                                <ul className='row'>
                                    <h3 className="mt-3 mb-2">
                                        How <span className="key_features">Vanani & Associates Adds Value</span>
                                    </h3>
                                    <p className='mb-4'>
                                        Our tax audit services go beyond the conventional approach to provide
                                        <strong> strategic benefits </strong> to our clients:
                                    </p>

                                    {/* 1 — Expertise in Complex Taxation Laws */}
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img
                                                    src='/images/expertise_in_complex.png'
                                                    width="55"
                                                    alt="Expertise in Complex Taxation Laws"
                                                />
                                                <p>
                                                    <strong>Expertise in Complex Taxation Laws</strong> Our Chartered Accountants stay updated with the latest amendments, judicial rulings, and regulatory changes to ensure accurate and compliant tax audits.
                                                </p>
                                            </div>
                                        </li>
                                    </div>

                                    {/* 2 — Advanced Audit Techniques */}
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img
                                                    src='/images/expert_guidance.png'
                                                    width="55"
                                                    alt="Advanced Audit Techniques"
                                                />
                                                <p>
                                                    <strong>Advanced Audit Techniques:</strong> We leverage cutting-edge audit tools and analytics to identify discrepancies, streamline processes, and optimize compliance.
                                                </p>
                                            </div>
                                        </li>
                                    </div>

                                    {/* 3 — Industry-Specific Knowledge */}
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img
                                                    src='/images/proactive_monitoring.png'
                                                    width="55"
                                                    alt="Industry-Specific Knowledge"
                                                />
                                                <p>
                                                    <strong>Industry-Specific Knowledge</strong> With extensive experience across diverse sectors, we tailor our audit methodologies to meet the unique needs of industries such as manufacturing, IT, retail, healthcare, and more.
                                                </p>
                                            </div>
                                        </li>
                                    </div>

                                    {/* 4 — Personalized Service */}
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img
                                                    src='/images/personalized_service.png'
                                                    width="55"
                                                    alt="Personalized Service"
                                                />
                                                <p>
                                                    <strong>Personalized Service</strong> We customize our approach to align with your specific business requirements, ensuring a seamless and stress-free experience.
                                                </p>
                                            </div>
                                        </li>
                                    </div>

                                    {/* 5 — Risk Mitigation */}
                                    <div className='col-md-6'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img
                                                    src='/images/risk_mitigation.png'
                                                    width="55"
                                                    alt="Risk Mitigation"
                                                />
                                                <p>
                                                    <strong>Risk Mitigation</strong> Our detailed audit reports provide actionable insights to rectify issues and reduce the risk of tax disputes or penalties.
                                                </p>
                                            </div>
                                        </li>
                                    </div>
                                </ul>
                            </div>
                            <section className="process_we_follow radius">
                                <div className="container">
                                    <h4 className="mt-0 mb-5">
                                        Process <span className="key_features">We Follow</span>
                                    </h4>

                                    <div className="glass-grid">
                                        {/* 01 — Pre-Audit Planning */}
                                        <div className="glass-card">
                                            <div className="floating-icon">
                                                <img
                                                    src="/images/pre_audit_planning.png"
                                                    alt="Pre-Audit Planning"
                                                />
                                            </div>
                                            <span className="step-number">01</span>
                                            <h3>Pre-Audit Planning</h3>
                                            <ul>
                                                <li>Understanding the client’s business operations and financial structure.</li>
                                                <li>Defining audit scope and timelines based on needs and regulations.</li>
                                            </ul>
                                        </div>

                                        {/* 02 — Execution Phase */}
                                        <div className="glass-card">
                                            <div className="floating-icon">
                                                <img
                                                    src="/images/execution_phase.png"
                                                    alt="Execution Phase"
                                                />
                                            </div>
                                            <span className="step-number">02</span>
                                            <h3>Execution Phase</h3>
                                            <ul>
                                                <li>Detailed examination of books, records, and compliance with provisions.</li>
                                                <li>Verification of income, deductions, depreciation, and tax liability.</li>
                                            </ul>
                                        </div>

                                        {/* 03 — Reporting */}
                                        <div className="glass-card">
                                            <div className="floating-icon">
                                                <img
                                                    src="/images/reporting_1.png"
                                                    alt="Reporting"
                                                />
                                            </div>
                                            <span className="step-number">03</span>
                                            <h3>Reporting</h3>
                                            <ul>
                                                <li>Preparation and submission of Form 3CA/3CB and Form 3CD.</li>
                                                <li>Clear, actionable recommendations to improve compliance and accuracy.</li>
                                            </ul>
                                        </div>

                                        {/* 04 — Post-Audit Assistance */}
                                        <div className="glass-card">
                                            <div className="floating-icon">
                                                <img
                                                    src="/images/post_audit_assistance.png"
                                                    alt="Post-Audit Assistance"
                                                />
                                            </div>
                                            <span className="step-number">04</span>
                                            <h3>Post-Audit Assistance</h3>
                                            <ul>
                                                <li>Addressing queries from tax authorities.</li>
                                                <li>Supporting implementation of audit recommendations.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div className='benefits_our_tax_audit_services mt-5'>
                                <div className='col-md-12'>
                                    <div className='check_list_wrap mt-2'>
                                        <h4 className='mt-0 mb-3'>Benefits of Our Tax Audit Services</h4>
                                        <ul>
                                            <li><strong>Regulatory Compliance: </strong>Ensures timely and accurate adherence to all statutory provisions under the Income Tax Act.</li>
                                            <li><strong>Enhanced Credibility: </strong>Builds trust among stakeholders with transparent and reliable financial records.</li>
                                            <li><strong>Risk Minimization: </strong>identifies and addresses discrepancies or risks in tax reporting.</li>
                                            <li><strong>Operational Efficiency: </strong>Optimizes internal controls and accounting systems, leading to better decision-making.</li>
                                            <li><strong>Seamless Tax Filing: </strong>Facilitates error-free tax return filing, reducing the likelihood of scrutiny or penalties.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="check_list_wrap mt-5 mb-5 compliance_checklist_flow">
                                    <h4 className="mt-3 mb-4">Why Choose <sapn className="key_features">Vanani & Associates? </sapn></h4>
                                    <div className="checklist-flow">
                                        <div className="checklist-item">
                                            <span className="check-icon">🏆</span>
                                            <div className="check-content">
                                                <strong>Proven Track Record:</strong> Decades of experience in handling tax audits for businesses of all sizes.
                                            </div>
                                        </div>

                                        <div className="checklist-item">
                                            <span className="check-icon">🤝</span>
                                            <div className="check-content">
                                                <strong>Comprehensive Support:</strong> End-to-end assistance, from audit planning to report submission.
                                            </div>
                                        </div>

                                        <div className="checklist-item">
                                            <span className="check-icon">✔️</span>
                                            <div className="check-content">
                                                <strong>Focus on Quality:</strong> Rigorous internal checks to ensure the highest standards of accuracy and reliability.
                                            </div>
                                        </div>

                                        <div className="checklist-item">
                                            <span className="check-icon">💼</span>
                                            <div className="check-content">
                                                <strong>Commitment to Clients:</strong> Dedicated to delivering timely, value-driven solutions tailored to your unique needs.
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <section className="conclusion-section">
                                    <div className="conclusion-content">
                                        <h2>Conclusion</h2>
                                        <ul className='px-3 mx-1'>
                                            <li>  A tax audit is not just about compliance—it’s a gateway to improving financial accuracy,
                                            strengthening internal controls, and building trust with stakeholders.
                                            At <strong>Vanani & Associates</strong>, we’re committed to delivering exceptional tax audit services 
                                            that empower your business to achieve its goals with confidence.</li>
                                        </ul>
                                        <div className="cta-box">
                                            <h3>Get in Touch Today!</h3>
                                            <p>
                                                Partner with Vanani & Associates for seamless and accurate tax audit services.
                                            </p>
                                        </div>
                                    </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Tax_Audit_Services;
